import {GetStaticProps} from "next";
import {MarkdownMetaDataInterface} from "../interfaces/MarkdownMetaDataInterface";
import {getStaticPropsForMarkdownPage} from "../helpers/GetStaticPropsForMarkdownPage";
import {getSafeLocale} from "../helpers/LocalizeObject";
import ContactUsContent from "../components/common/ContactUsContent";
import HeaderImageWithHeading from "../components/common/HeaderImageWithHeading";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";


function Page({
	              result,
	              markdown: MDXFile,
              }: {
	result: MarkdownMetaDataInterface;
	markdown: any;
}) {

	return (<>
			<HeaderImageWithHeading imageSrc={result.metadata.metadata.image}
	                                  title=""
	                                  subtitle=""
	                                  subtitle2=""/>
			<ContactUsContent/>
		</>
	);
}

export const getStaticProps: GetStaticProps = async (context) => {
	return getStaticPropsForMarkdownPage(getSafeLocale(context.locale)!, "ueberuns");
};

export default Page;
